import {observer} from 'mobx-react';
import {Panel, FormLayout, ObjectSelect2, QuickTip} from 'shared/components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const MissingIntegrationsWarning = observer(({uiState}) => {
  const {interviewersMissingConnections, currentUserMissingConnections, otherUsersMissingConnections} = uiState;

  if (_.isEmpty(interviewersMissingConnections)) return null;

  const paragraphs = [
    <FormattedMessage
      key='explainer'
      id='recruiting.interview_schedules.edit.interviewers.The following users have not connected their calendars and/or meeting apps to Collage:'
    />,
    <ul key='users-list' className='mb0'>
      {interviewersMissingConnections.map(u => <li className='ml3' key={u.id}>{u.name}</li>)}
    </ul>,
    <FormattedMessage
      key='explainer'
      id='recruiting.interview_schedules.edit.interviewers.You will not be able to use this interview schedule until all users have set up their required integrations.'
    />
  ];

  if (otherUsersMissingConnections) {
    paragraphs.push(
      <FormattedMessage id='recruiting.interview_schedules.edit.interviewers.Users will be notified by email to connect these apps to Collage.'/>
    );
  }

  if (currentUserMissingConnections) {
    paragraphs.push(
      <FormattedMessage
        id='recruiting.interview_schedules.edit.interviewers.USER_SETTINGS_LINK'
        values={{user_settings: <a href='/user_settings' target='_blank'><FormattedMessage id='recruiting.interview_schedules.edit.interviewers.personal settings'/></a>}}
      />
    );
  }

  return (
    <div className='mb2'>
      <QuickTip
        trait='caution'
        header={<FormattedMessage id='recruiting.interview_schedules.edit.interviewers.Missing integrations'/>}
        paragraphs={paragraphs}
      />
    </div>
  );
});

const Interviewers = observer(({uiState}) => {
  const {interviewSchedule, users, errors} = uiState;
  const {interviewers, eventHost} = interviewSchedule;

  return (
    <div>
      <Panel.Header title={t('recruiting.interview_schedules.edit.Interviewers')}/>
      <FormLayout>
        <ObjectSelect2
          value={interviewers}
          items={users}
          by='id'
          display='name'
          multiple
          searchable
          label='recruiting.interview_schedules.edit.Interviewers'
          placeholder='recruiting.interview_schedules.edit.Add an interviewer'
          onAdd={user => interviewSchedule.addInterviewer(user)}
          onRemove={user => interviewSchedule.removeInterviewer(user)}
          errorMessage={errors.interviewerIds}
        />
        <ObjectSelect2
          value={eventHost}
          items={users}
          by='id'
          display='name'
          allowClear
          searchable
          label='recruiting.interview_schedules.edit.Meeting Host'
          placeholder='recruiting.interview_schedules.edit.Select a meeting host'
          onChange={user => interviewSchedule.merge({eventHost: user})}
          errorMessage={errors.eventHostId}
        />
        <MissingIntegrationsWarning uiState={uiState}/>
      </FormLayout>
    </div>
  );
});

export default Interviewers;
